define([
  "marionette",
  "backbone",
  "underscore",
  "messaging/messenger",
  "modules/admin/userAdministration/userDetails/roleMapDisplay/roleMapView",
  "modules/admin/userAdministration/usersModel",
], function (Marionette, Backbone, _, Messenger, RoleMapView, UsersModel) {
  "use strict";

  return Marionette.Controller.extend({
    initialize: function (options) {
      this.region = options.region;
      this.kbRoles = options.kbRoles;
      this.tenantKbRoles = options.tenantKbRoles;
      this.roleMap = options.roleMap;
      this.isTenantAdmin = false; //boolean representing whether the edited user is a tenant admin
      this.name = "roleMapModule";
      this._setUpVents();
    },
    show: function (kbId, taskManagement, adHocReporting, recommendations) {
      this.roleMap.onSynced(function () {
        if (!this.kbRoles) {
          this._continueShow(kbId, taskManagement, adHocReporting, recommendations);
        } else {
          if (!this.kbRoles.isRequested) {
            try {
              this.kbRoles.fetch();
              this.kbRoles.onSynced(function () {
                this._continueShow(kbId, taskManagement, adHocReporting, recommendations);
              }, this);
            } catch (error) {
              console.error("Error fetching KB roles:", error);
              this._continueShow(kbId, taskManagement, adHocReporting, recommendations);
            }
          }
        }
      }, this);
    },
    _continueShow: function (kbId, taskManagement, adHocReporting, recommendations) {
      //We set the model to be the touchpoints where the kb is whatever the current KB is
      let model = this.roleMap.findWhere({ kbId: kbId });
      if (model === undefined) {
        this.roleMap.createUserRole(kbId);
        model = this.roleMap.findWhere({ kbId: kbId });
      }
      model.isTaskManagement = taskManagement;
      model.isAdHocReporting = adHocReporting;
      model.isTopicImporter = recommendations;
      model.kbRolesForKb = null;
      model.noKbRolesActive = true;
      if (!this.isTenantAdmin) {
        const rolesToCheck =
          this.kbRoles && this.kbRoles.length > 0 ? this.kbRoles : this.tenantKbRoles;

        const kbRolesForKb = rolesToCheck.filter((kbRole) => {
          if (kbRole.get("kbId") === kbId) {
            if (kbRole.get("active")) {
              model.noKbRolesActive = false;
            }
            return true;
          }
          return false;
        });
        if (kbRolesForKb && kbRolesForKb.length) {
          model.kbRolesForKb = new UsersModel.userKbRoles(kbRolesForKb);
        }
      }
      //check if the edited user is a tenant admin. If so, then make it look like all the roles
      //are enabled and disable the checkboxes from being edited.
      model.isTenantAdmin = this.isTenantAdmin;

      this.view = new RoleMapView.roleMapView({ model: model });
      this.view.on(
        "show",
        function () {
          this._showSubViews();
        },
        this,
      );

      this.view.on(
        "change:authoringRoles",
        function (kbRoleIds) {
          model.noKbRolesActive = true;
          model.kbRolesForKb.each(function (kbRole) {
            kbRole.set("active", false);
          });
          _.each(kbRoleIds, function (kbRoleId) {
            const kbRole = model.kbRolesForKb.get(kbRoleId);
            kbRole.set("active", true);
            model.noKbRolesActive = false;
          });
        },
        this,
      );

      this.view.on(
        "toggle:authoring",
        function () {
          model.set("authoring", !model.get("authoring"));
          this.view.render();
        },
        this,
      );

      this.view.on(
        "toggle:reporting",
        function () {
          model.set("reporting", !model.get("reporting"));
          this.view.render();
        },
        this,
      );

      this.view.on(
        "toggle:adHocReporting",
        function () {
          model.set("adHocReporting", !model.get("adHocReporting"));
          this.view.render();
        },
        this,
      );

      this.view.on(
        "toggle:adHocReportingAdmin",
        function () {
          model.set("adHocReportingAdmin", !model.get("adHocReportingAdmin"));
          this.view.render();
        },
        this,
      );

      this.view.on(
        "toggle:reviewer",
        function () {
          model.set("reviewer", !model.get("reviewer"));
          this.view.render();
        },
        this,
      );

      this.view.on(
        "toggle:reviewerWithAttributes",
        function () {
          model.set("reviewerWithAttributes", !model.get("reviewerWithAttributes"));
          this.view.render();
        },
        this,
      );

      this.view.on(
        "toggle:topicImportAPI",
        function () {
          model.set("topicImportAPI", !model.get("topicImportAPI"));
          this.view.render();
        },
        this,
      );

      this.showRegion(this.view);
    },
    _showSubViews: function () {},

    _setUpVents: function () {
      //Whenever a different KB is selected, we re-initialize the show method,
      //with the new KB.  This will refresh the module appropriately.
      Messenger.vent.on(
        "change:selected:kb",
        function (newKbId, taskManagement, adHocReporting, recommendations) {
          //save old stuff
          //display new stuff
          this.roleMap.onSynced(function () {
            this.show(newKbId, taskManagement, adHocReporting, recommendations);
          }, this);
        },
        this,
      );

      //Register when the edited user has the tenant admin property changed
      //Also called when the user details modal first loads, in which case this
      //module may not be shown yet.
      Messenger.vent.on(
        "changed:edited:user:tenant:admin",
        function (isTenantAdmin) {
          this.isTenantAdmin = isTenantAdmin;
          if (this.view) {
            this.view.model.isTenantAdmin = isTenantAdmin;
            this.view.render();
          }
        },
        this,
      );
    },
  });
});
